import { render, staticRenderFns } from "./ManageOwnCustomer.vue?vue&type=template&id=65c64049&"
import script from "./ManageOwnCustomer.vue?vue&type=script&lang=js&"
export * from "./ManageOwnCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports